import React, { Component } from 'react';
import Drawer from 'material-ui/Drawer';
import MenuItem from 'material-ui/MenuItem';
import NavStore from '../stores/NavStore';
import { observer } from 'mobx-react'
import { Link } from 'react-router-dom'

export default observer(class DrawerObject extends Component {

  handleToggle = () => NavStore.Toggle()

  handleClose = () => NavStore.Close()

  goHome = () => {
    NavStore.Status = false
    location.href = "/m/"
  }

  render() {
    return (
      <div>
        <Drawer
          docked={false}
          width={200}
          open={NavStore.Status}
          onRequestChange={this.handleToggle}
        >
          {/*<MenuItem onTouchTap={this.goHome}>回首頁</MenuItem>*/}
          <Link to={`/hdept2doc`} style={{ textDecoration: 'none' }}>
            <MenuItem onClick={this.handleClose}>
              依科別找醫師
            </MenuItem>
          </Link>
          <Link to={`/doc2hdept`} style={{ textDecoration: 'none' }}>
            <MenuItem onClick={this.handleClose}>
              依醫師找科別
            </MenuItem>
          </Link>
        </Drawer>
      </div>
    );
  }
})


// WEBPACK FOOTER //
// ./src/components/Nav.js